import { Contrato, CreateContratoRequest, UpdateContratoRequest } from './contrato.interface';
import {
  ContratoDto,
  ContratoWithDetailsDto,
  CreateContratoDto,
  UpdateContratoDto,
  CreateContratoResponseDto
} from './contrato.dto';

export class ContratoMapper {
  static fromDto(dto: ContratoDto): Contrato {
    return {
      numeroContratoId: dto.NumeroContrato_ID,
      numeroContrato: dto.Numero_Contrato,
      anioContrato: dto.Anio_Contrato,
      tipoContratoId: dto.TipoContrato_ID,
      perfilId: dto.Perfil_ID,
      valorHonorariosMes: dto.ValorHonorarios_Mes,
      beneficiario: dto.Beneficiario
    };
  }

  static fromDtoWithDetails(dto: ContratoWithDetailsDto): Contrato {
    return {
      numeroContratoId: dto.contrato_ID,
      numeroContrato: dto.numero_Contrato,
      anioContrato: dto.anio_Contrato,
      tipoContratoId: dto.tipoContrato_ID,
      perfilId: dto.perfil_ID,
      valorHonorariosMes: dto.valorHonorarios,
      beneficiario: dto.beneficiario,
      tipoContratoNombre: dto.tipoContratoNombre,
      perfilNombre: dto.perfilNombre
    };
  }

  static fromDtoList(dtoList: ContratoDto[]): Contrato[] {
    return dtoList.map(dto => this.fromDto(dto));
  }

  static fromDtoWithDetailsList(dtoList: ContratoWithDetailsDto[]): Contrato[] {
    return dtoList.map(dto => this.fromDtoWithDetails(dto));
  }

  static fromCreateResponseDto(dto: CreateContratoResponseDto): Contrato {
    return {
      numeroContratoId: dto.contrato_ID,
      numeroContrato: dto.numero_Contrato,
      anioContrato: dto.anio_Contrato,
      tipoContratoId: dto.tipoContrato_ID,
      perfilId: dto.perfil_ID,
      valorHonorariosMes: dto.valorHonorarios,
      beneficiario: dto.beneficiario
    };
  }

  static toDto(model: Contrato): ContratoDto {
    return {
      NumeroContrato_ID: model.numeroContratoId,
      Numero_Contrato: model.numeroContrato,
      Anio_Contrato: model.anioContrato,
      TipoContrato_ID: model.tipoContratoId,
      Perfil_ID: model.perfilId,
      ValorHonorarios_Mes: model.valorHonorariosMes,
      Beneficiario: model.beneficiario
    };
  }

  static toCreateDto(request: CreateContratoRequest): CreateContratoDto {
    return {
      Numero_Contrato: request.numeroContrato,
      Anio_Contrato: request.anioContrato,
      TipoContrato_ID: request.tipoContratoId,
      Perfil_ID: request.perfilId,
      ValorHonorarios: request.valorHonorariosMes,
      Beneficiario: request.beneficiario
    };
  }

  static toUpdateDto(request: UpdateContratoRequest): UpdateContratoDto {
    return {
      Numero_Contrato: request.numeroContrato,
      Anio_Contrato: request.anioContrato,
      TipoContrato_ID: request.tipoContratoId,
      Perfil_ID: request.perfilId,
      ValorHonorarios: request.valorHonorariosMes,
      Beneficiario: request.beneficiario
    };
  }
}
